export const DAYS = [7, 15, 30, 90, 180]

export const SCENE = [
  {
    key: 1,
    label: '社区'
  }, {
    key: 2,
    label: 'APP'
  }, {
    key: 4,
    label: '推广'
  }
]

export const STRONG = [
  {
    key: 0,
    label: '不限'
  },
  {
    key: 1,
    label: '高强度'
  }
]
